import type { ReelItem } from '~/components/PropertyReelsFeed/types';

import { defineStore } from 'pinia';

export const useVideoHistoryStore = defineStore('videoHistory', () => {
	const historyItems = shallowRef<ReelItem[]>([]);
	const historyPage = ref(1);
	const hasMoreHistory = ref(true);
	const isLoadingHistory = ref(false);
	const isHistoryLoaded = ref(false);

	function setItems(items: ReelItem[]) {
		historyItems.value = items;
	}

	function prependItems(items: ReelItem[]) {
		historyItems.value = [...items, ...historyItems.value];
	}

	function reset() {
		historyItems.value = [];
		historyPage.value = 1;
		hasMoreHistory.value = true;
		isLoadingHistory.value = false;
		isHistoryLoaded.value = false;
	}

	return {
		historyItems,
		historyPage,
		hasMoreHistory,
		isLoadingHistory,
		isHistoryLoaded,
		setItems,
		prependItems,
		reset
	};
});
